import "./App.css";

import { BrowserRouter as Router, Route } from "react-router-dom";
import Index from "./Routes/Index";
import React from "react";
import {IntlProvider} from 'react-intl';
import { messages } from "./lang/translations";

export default function App() {
  var language=navigator.language.split("-")[0];
  if (window.sessionStorage.getItem("lang")===null) {
  if (language !== "cs"){ window.location.href = '/' };
  }
  window.sessionStorage.setItem("lang","cs");
  language = "cs";
const langMessages = language in messages ? messages[language as keyof typeof messages] : messages.en
const locale = language in messages ? language : "en"  
return (
    <IntlProvider messages={langMessages} locale={locale} defaultLocale="en">
    <Router>
      <Route path="/cs/" exact>
        <Index />
      </Route>
    </Router>
    </IntlProvider>
  );
}
